import { CoreBaseLoader } from "./../_Base";
export class BaseTextureLoader extends CoreBaseLoader {
  constructor(_url, _node) {
    super(_url, _node);
    this._node = _node;
  }
}
